const durationUserInfo = 5 * 60 * 1000; // 5 minutes

export default durationUserInfo;
